import { defineComponent as _defineComponent } from 'vue';
import { ref, useId } from "vue";
import { ChevronRight } from "lucide-vue-next";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CollapsibleCard',
    props: {
        title: { type: String, required: true },
        count: { type: Number, required: false, default: undefined },
        defaultOpen: { type: Boolean, required: false, default: true },
        headingLevel: { type: Number, required: false, default: 3 }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const isOpen = ref(props.defaultOpen);
        // Unique IDs for aria-controls / aria-labelledby linking
        const generatedId = useId();
        const buttonId = `collapsible-card-btn-${generatedId}`;
        const panelId = `collapsible-card-panel-${generatedId}`;
        const toggleCard = () => {
            isOpen.value = !isOpen.value;
        };
        const __returned__ = { props, isOpen, generatedId, buttonId, panelId, toggleCard, get ChevronRight() { return ChevronRight; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
